// ForestBackground.jsx
import React, { useEffect } from 'react';

const ForestBackground = () => {
  useEffect(() => {
    // Create falling leaves
    const createLeaf = () => {
      const leaf = document.createElement('div');
      leaf.className = `leaf-particle leaf-${Math.floor(Math.random() * 4) + 1}`;
      leaf.style.left = Math.random() * 100 + 'vw';
      leaf.style.width = (Math.random() * 15 + 8) + 'px';
      leaf.style.height = (Math.random() * 15 + 8) + 'px';
      leaf.style.animationDuration = (Math.random() * 10 + 15) + 's';
      leaf.style.animationDelay = Math.random() * 5 + 's';
      document.querySelector('.forest-background').appendChild(leaf);
      
      // Remove leaf after animation
      setTimeout(() => {
        if (leaf.parentNode) {
          leaf.parentNode.removeChild(leaf);
        }
      }, 20000);
    };

    // Create stars
    const createStars = () => {
      const sky = document.querySelector('.sky');
      for (let i = 0; i < 30; i++) {
        const star = document.createElement('div');
        star.className = 'star';
        star.style.left = Math.random() * 100 + 'vw';
        star.style.top = Math.random() * 50 + 'vh';
        star.style.width = (Math.random() * 2 + 1) + 'px';
        star.style.height = star.style.width;
        star.style.animationDelay = Math.random() * 4 + 's';
        sky.appendChild(star);
      }
    };

    // Create clouds - FIXED
    const createCloud = () => {
        const cloud = document.createElement('div');
        cloud.className = 'cloud';
        cloud.style.top = (Math.random() * 30 + 10) + 'vh';
        
        // Calculate width first as a number
        const cloudWidth = Math.random() * 80 + 40;
        cloud.style.width = cloudWidth + 'px';
        
        // Now use the numeric value for height calculation
        cloud.style.height = (cloudWidth * 0.6) + 'px';
        
        cloud.style.animationDuration = (Math.random() * 60 + 120) + 's';
        cloud.style.animationDelay = Math.random() * -60 + 's';
        cloud.style.left = '-100px';
        
        document.querySelector('.sky').appendChild(cloud);
        
        // Remove cloud after animation
        setTimeout(() => {
          if (cloud.parentNode) {
            cloud.parentNode.removeChild(cloud);
          }
        }, 130000);
      };

    // Create berry bushes
    const createBerryBush = () => {
      const bush = document.createElement('div');
      bush.className = 'berry-bush';
      bush.style.left = Math.random() * 90 + 5 + 'vw'; // Keep within view
      
      // Add berries
      const berryCount = Math.floor(Math.random() * 4) + 3;
      for (let i = 0; i < berryCount; i++) {
        const berry = document.createElement('div');
        berry.className = 'berry';
        berry.style.left = (Math.random() * 60 + 20) + '%';
        berry.style.top = (Math.random() * 40 + 30) + '%';
        berry.style.animationDelay = (Math.random() * 2) + 's';
        bush.appendChild(berry);
      }
      
      document.querySelector('.forest-background').appendChild(bush);
    };

    // Initialize background elements
    createStars();
    
    // Create initial leaves
    for (let i = 0; i < 15; i++) {
      setTimeout(createLeaf, i * 500);
    }
    
    // Create initial clouds
    for (let i = 0; i < 3; i++) {
      createCloud();
    }
    
    // Create berry bushes
    for (let i = 0; i < 6; i++) {
      createBerryBush();
    }

    // Continue creating elements
    const leafInterval = setInterval(createLeaf, 1000);
    const cloudInterval = setInterval(createCloud, 15000);
    
    return () => {
      clearInterval(leafInterval);
      clearInterval(cloudInterval);
    };
  }, []);

  return (
    <div className="forest-background">
      <div className="sky"></div>
      <div className="grass"></div>
      <div className="ground"></div>
      
      {/* Centered Tree SVGs */}
      <svg className="tree tree-1" viewBox="0 0 120 400">
        <path className="tree-trunk" d="M55,400 L65,400 L65,280 L55,280 Z"/>
        <path className="tree-leaves" d="M10,280 L60,200 L110,280 L10,280 Z M15,250 L60,170 L105,250 L15,250 Z M20,220 L60,140 L100,220 L20,220 Z M25,190 L60,110 L95,190 L25,190 Z M30,160 L60,80 L90,160 L30,160 Z"/>
      </svg>
      
      <svg className="tree tree-2" viewBox="0 0 140 500">
        <path className="tree-trunk" d="M65,500 L75,500 L75,320 L65,320 Z"/>
        <path className="tree-leaves-2" d="M10,320 L70,220 L130,320 L10,320 Z M15,290 L70,190 L125,290 L15,290 Z M20,260 L70,160 L120,260 L20,260 Z M25,230 L70,130 L115,230 L25,230 Z M30,200 L70,100 L110,200 L30,200 Z"/>
      </svg>
      
      <svg className="tree tree-3" viewBox="0 0 100 350">
        <path className="tree-trunk" d="M45,350 L55,350 L55,240 L45,240 Z"/>
        <path className="tree-leaves-3" d="M5,240 L50,170 L95,240 L5,240 Z M10,220 L50,150 L90,220 L10,220 Z M15,200 L50,130 L85,200 L15,200 Z M20,180 L50,110 L80,180 L20,180 Z"/>
      </svg>
      
      <svg className="tree tree-4" viewBox="0 0 130 450">
        <path className="tree-trunk" d="M60,450 L70,450 L70,300 L60,300 Z"/>
        <path className="tree-leaves" d="M15,300 L65,210 L115,300 L15,300 Z M20,270 L65,180 L110,270 L20,270 Z M25,240 L65,150 L105,240 L25,240 Z M30,210 L65,120 L100,210 L30,210 Z M35,180 L65,90 L95,180 L35,180 Z"/>
      </svg>
      
      <svg className="tree tree-5" viewBox="0 0 110 380">
        <path className="tree-trunk" d="M50,380 L60,380 L60,260 L50,260 Z"/>
        <path className="tree-leaves-2" d="M5,260 L55,180 L105,260 L5,260 Z M10,240 L55,160 L100,240 L10,240 Z M15,220 L55,140 L95,220 L15,220 Z M20,200 L55,120 L90,200 L20,200 Z M25,180 L55,100 L85,180 L25,180 Z"/>
      </svg>
      
      {/* Bushes */}
      <svg className="bush bush-1" viewBox="0 0 150 80">
        <path d="M0,80 C30,50 60,60 75,40 C90,60 120,50 150,80 L0,80 Z"/>
      </svg>
      
      <svg className="bush bush-2" viewBox="0 0 180 70">
        <path d="M0,70 C40,40 70,50 90,30 C110,50 140,40 180,70 L0,70 Z"/>
      </svg>
      
      <svg className="bush bush-3" viewBox="0 0 120 60">
        <path d="M0,60 C20,40 40,45 60,30 C80,45 100,40 120,60 L0,60 Z"/>
      </svg>
    </div>
  );
};

export default ForestBackground;